// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui-action-content-hYBnsU{display:flex}.action-btn-zOKyl2{margin-right:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-action-content": `ui-action-content-hYBnsU`,
	"uiActionContent": `ui-action-content-hYBnsU`,
	"action-btn": `action-btn-zOKyl2`,
	"actionBtn": `action-btn-zOKyl2`
};
export default ___CSS_LOADER_EXPORT___;
